// extracted by mini-css-extract-plugin
export default {"inner-card":"Card_inner-card__tsEat","primary-card":"Card_primary-card__YbD1c","tag-card":"Card_tag-card__wA+mt"};